import React from "react";
import { Routes, Route } from "react-router-dom";
import App from "./App";
import PortfolioPage from "./Portfolio";
import { ServicesPage } from "./Services";
import { ContactUs } from "./Contact";
import ServiceDetail from "./ServiceDetail";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/contact-us" element={<ContactUs />} />
    </Routes>
  );
};

export default Router;
